var constants = require('./constants')
var format = require('util').format

exports.successOnly = function(tx) {
  return tx.meta.TransactionResult == constants.transactionResults.SUCCESS
}



//////////////////
// WEBPACK FOOTER
// ./src/helpers/transactions.js
// module id = 475
// module chunks = 0